
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#050606","d":"M9.189 4.052a.5.5 0 01-.5-.5V1.983a.5.5 0 011 0v1.569a.5.5 0 01-.5.5z"}}),_c('path',{attrs:{"d":"M11.023.104H1.328C.651.104.103.572.103 1.15v12.701c0 .577.548 1.046 1.225 1.046H13.67c.676 0 1.226-.469 1.226-1.046V3.407L11.023.104zm-.82 1.047v3.233H4.794V1.151h5.409zM3.464 13.82V7.999h8.069v5.821H3.464zm10.206.076h-1.137V7.499a.5.5 0 00-.5-.5H2.964a.5.5 0 00-.5.5v6.397H1.328c-.123 0-.2-.049-.22-.049-.003 0-.004.001-.005.003L1.095 1.188c.014-.023.095-.084.233-.084h2.466v3.781a.5.5 0 00.5.5h6.409a.5.5 0 00.5-.5V1.571l2.692 2.297.009 9.943c-.013.023-.095.085-.234.085z"}})])
          )
        }
      }
    